<template>
    <div>
        <form @submit.prevent="submit">
            <div>
                <text-field
                    label="Email"
                    type="email"
                    v-model="form.email"
                    required
                    autofocus
                    autocomplete="username"
                />
            </div>

            <div class="mt-4">
                <text-field
                    label="Password"
                    type="password"
                    v-model="form.password"
                    required
                    autocomplete="new-password"
                />
            </div>

            <div class="mt-4">
                <text-field
                    label="Confirm Password"
                    type="password"
                    v-model="form.password_confirmation"
                    required
                    autocomplete="new-password"
                />
            </div>

            <div class="d-flex justify-end mt-4">
                <v-btn
                    :loading="form.processing"
                    :disabled="form.processing"
                    type="submit"
                >
                    Reset Password
                </v-btn>
            </div>
        </form>
    </div>
</template>

<script>
import BreezeGuestLayout from "@/Layouts/GuestLayout";
import TextField from "../../Components/Forms/TextField";

export default {
    layout: BreezeGuestLayout,

    components: {
        TextField,
    },

    props: {
        email: String,
        token: String,
    },

    data() {
        return {
            form: this.$inertia.form({
                token: this.token,
                email: this.email,
                password: "",
                password_confirmation: "",
            }),
        };
    },

    methods: {
        submit() {
            this.form.post(this.route("password.update"), {
                onFinish: () =>
                    this.form.reset("password", "password_confirmation"),
            });
        },
    },
};
</script>
